// extracted by mini-css-extract-plugin
export default {"summary-container":"GWq0mwfR7Pvj2QZWp1kh"};